import { TriggeredHook } from "sonobello.utilities.react";

import TriggeredHookContextDecorator from "../../App/Compositions/TriggeredHookContextDecorator";
import useUpsertCustomerNote from "../Hooks/useUpsertCustomerNote";

/** A hook which create or update customer notes appropriately when triggered with the desired content. */
const ComposedUseUpsertCustomerNote: TriggeredHook<unknown, string, boolean> = TriggeredHookContextDecorator(
  useUpsertCustomerNote,
  ({ customerCState, leadIdCState }) => ({
    leadId: leadIdCState,
    customerId: customerCState.id,
    centerId: customerCState.centerId
  })
);

export default ComposedUseUpsertCustomerNote;
